// extracted by mini-css-extract-plugin
export default {"modal_container":"styles_modal_container__LD0Kh","modal":"styles_modal__Ybd4p","content":"styles_content__IecPt","header":"styles_header__1w5WQ","footer":"styles_footer__S7biV"};